<template>
    <div class="bg-white">
        <main>
            <!-- Alternating Feature Sections -->
            <div class="relative pt-16 pb-32 overflow-hidden">
                <div aria-hidden="true" class="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100"></div>






                <div class="relative">
                    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                            <div>
                                <div class="mt-6">
                                    <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                        Správa auditů a dokumentace
                                    </h2>
                                    <p class="mt-4 text-lg text-gray-500">
                                        Spravujte jednoduše a efektivně všechnu svou dokumentaci! EKOffice Vám umožňuje vytvářet vlastní kategorie a nastavovat parametry dokumentům tak, abyste na nic nemuseli myslet. V případě vyhodnocení rizika Vás systém sám upozorní.
                                    </p>
                                    <div class="mt-6">
                                        <a href="#" style="background-color: #007bff;" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white">
                                            Registrovat
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-8 border-t border-gray-200 pt-6">
                                <blockquote>
                                    <div>
                                        <p class="text-base text-gray-500">
                                            &ldquo;EKOffice je produkt bohatých zkušeností a profesionálního přístupu, který ocenila již řada dlouhodobých klientů a partnerů jak z oblasti velkých korporací tak i menších firem. Všech našich klientů si vážíme a jejich spokojenost je pro nás zásadní. &rdquo;
                                        </p>
                                    </div>
                                    <footer class="mt-3">
                                        <div class="flex items-center space-x-3">
                                            <div class="shrink-0">
                                                <img class="h-6 w-6 rounded-full" src="/joomla/images/ekoffice/zoubek4.jpg" alt="">
                                            </div>
                                            <div class="text-base font-medium text-gray-700">
                                                Vlastimil Zoubek
                                            </div>
                                        </div>
                                    </footer>
                                </blockquote>
                            </div>
                        </div>
                        <div class="mt-12 sm:mt-16 lg:mt-0">
                            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="/joomla/images/ekoffice/img1.png">
                            </div>
                        </div>
                    </div>
                </div>










                <div class="">
                    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:grid-flow-col-dense lg:gap-24">
                        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2 col-span-2">
                            <div>
                                <div class="mt-6">
                                    <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                        Zaměstnanci na jednom místě
                                    </h2>
                                    <p class="mt-4 text-lg text-gray-500">
                                        S EKOffice máte informace o svých zaměstnancích, jejich dokumenty, certifikáty a komunikaci na jednom místě.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
                            <div class="pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" src="/joomla/images/ekoffice/img3.png" >
                            </div>
                        </div>
                    </div>
                </div>








                <div class="relative">
                    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-36 lg:max-w-none lg:mx-0 lg:px-0">
                            <div>
                                <div class="mt-6">
                                    <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                        Školení na míru
                                    </h2>
                                    <p class="mt-4 text-lg text-gray-500">
                                        Školení generujeme na míru z informací, které nám poskytnete. Pokud ani to není dost, můžete nás kontaktovat nebo si vytvořit školení vlastní.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-12 sm:mt-16 lg:mt-0">
                            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="/joomla/images/ekoffice/img2.png">
                            </div>
                        </div>
                    </div>
                </div>








                <div class="">
                    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:grid-flow-col-dense lg:gap-24">
                        <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2 col-span-2">
                            <div>
                                <div class="mt-6">
                                    <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                        Profesionální zákaznická podpora
                                    </h2>
                                    <p class="mt-4 text-lg text-gray-500">
                                        Uživatelé a jejich zaměstnanci nás mohou kdykoli kontaktovat přímo ze systému nebo zavolat na EKObena hotline, kde jim certifikovaný profesionál ihned pomůže.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
                            <div class="pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" src="/joomla/images/ekoffice/img4.png" >
                            </div>
                        </div>
                    </div>
                </div>




            </div>
        </main>

    </div>
</template>

<script>
export default {
    name: "Showcase"
}
</script>

<style scoped>

</style>
